<template>
  <svg
    width="23"
    height="22"
    viewBox="0 0 23 22"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect x="0.5" y="0.5" width="22" height="21" rx="4.5" stroke="#213E7A" />
    <path
      d="M14.0001 11.864C14.6666 11.479 14.6666 10.517 14.0001 10.132L9.50012 7.53398C8.83362 7.14898 8.00012 7.62998 8.00012 8.39998V13.596C8.00012 14.366 8.83362 14.847 9.50012 14.462L14.0001 11.864Z"
      stroke="#213E7A"
      stroke-width="1.2"
      stroke-linejoin="round"
    />
    <path
      d="M15.5 14.5V7.5"
      stroke="#213E7A"
      stroke-width="1.2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
</template>

<script>
export default {
  name: "StartDispatchIcon",
};
</script>

<style></style>
